/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

const namespaces = [
  "auth",
  "dashboard",
  "footer",
  "forgotPassword",
  "header",
  "landing",
  "learnMore",
  "myAccount",
  "mySites",
  "promoTools",
  "reportTracker",
  "setPassword",
  "signup",
  "sitebuilder",
  "static",
  "statistics",
  "support",
  "sitePromo",
  "oneClick",
  "userGuide",
  "news",
  "twoFactorAuth",
];

export default namespaces;
